<div [class.ghost]="ghostMode">
    <ion-item *ngFor="let faqNode of faqNodes; trackBy: trackById"
              class="card-content"
              (click)="selectFaqNode(faqNode)"
              detail="false">
        <ion-text class="medium-ghost-size">
            {{faqNode.title}}
        </ion-text>
        <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
    </ion-item>
</div>
